<template lang="pug">
  section.features.wrapper-p.bg-d-blue(data-id=`features`)
    h2.features__title.clr-white.t-h2 Преимущества

    .features__blocks.clr-white
      .features__block
        .features__block-icon.bg-d-blue
          svg(xmlns=`http://www.w3.org/2000/svg`)
            use(:href="$setSvgHref(`img/sprite.svg#i-features-01`)")

        .features__content
          .features__container.features__container--first
            h2.features__block-title.clr-white Единая точка управления бортовым оборудованием

          .features__container.features__container--second
            h4.features__subtitle.clr-white.t-h4 Единая точка управления

            base-list.advantages__list(:elements="lists.blocks[0].items")

      .features__block
        .features__block-icon.bg-d-blue
          svg(xmlns=`http://www.w3.org/2000/svg`)
            use(:href="$setSvgHref(`img/sprite.svg#i-features-02`)")

        .features__content
          .features__container.features__container--first
            h2.features__block-title.clr-white В базовой версии выделены 3 роли

          .features__container.features__container--second
            h4.features__subtitle.clr-white.t-h4 Многопользовательский доступ

            base-list.advantages__list(:elements="lists.blocks[1].items")

      .features__block
        .features__block-icon.bg-d-blue
          svg(xmlns=`http://www.w3.org/2000/svg`)
            use(:href="$setSvgHref(`img/sprite.svg#i-features-03`)")

        .features__content
          .features__container.features__container--first
            h2.features__block-title.clr-white ЦБК - единый центр связи для всей телеметрической инфраструктуры ТС

          .features__container.features__container--second
            h4.features__subtitle.clr-white.t-h4 Связь

            base-list.advantages__list(:elements="lists.blocks[2].items")

      .features__block
        .features__block-icon.bg-d-blue
          svg(xmlns=`http://www.w3.org/2000/svg`)
            use(:href="$setSvgHref(`img/sprite.svg#i-features-04`)")

        .features__content
          .features__container.features__container--first
            h2.features__block-title.clr-white 10.1 дюймовый сенсорный экран высокой контрастности

          .features__container.features__container--second
            h4.features__subtitle.clr-white.t-h4 Управление

            base-list.advantages__list(:elements="lists.blocks[3].items")

      .features__block
        .features__block-icon.bg-d-blue
          svg(xmlns=`http://www.w3.org/2000/svg`)
            use(:href="$setSvgHref(`img/sprite.svg#i-features-05`)")

        .features__content
          .features__container.features__container--first
            svg.features__scheme(xmlns=`http://www.w3.org/2000/svg`)
              use(:href="$setSvgHref(`img/sprite.svg#i-features-scheme`)")

          .features__container.features__container--second
            h4.features__subtitle.clr-white.t-h4 Собственное ПО

            base-list.advantages__list(:elements="lists.blocks[4].items")

            p.clr-white Установка прикладного программного обеспечения ЦБК может выполняться только специалистом организации-производителя или обслуживающей организации, прошедшей  соответствующее обучение в организации-производителе.

            p
              a(
                href=`upload/ЦБК. Руководство оператора v1.0.pdf`
                download
              ).clr-white.features__link
                svg(xmlns=`http://www.w3.org/2000/svg`)
                  use(:href="$setSvgHref(`img/sprite.svg#i-file`)")
                span.btn__text Скачать документ «ЦБК. Прикладное программное обеспечение. Руководство оператора»

            p
              a(
                href=`upload/ЕМ Свидетельство ЭВМ ЦБК.jpeg`
                download
              ).clr-white.features__link
                svg(xmlns=`http://www.w3.org/2000/svg`)
                  use(:href="$setSvgHref(`img/sprite.svg#i-file`)")
                span.btn__text Скачать документ «Свидетельство о регистрации программы для ЭВМ № 2021616702 от 26.04.2021»

</template>

<script>
export default {
  data () {
    return {
      lists: {
        blocks: [{
          items: [{
            class: `features__list-item`,
            text: `Ускоряет и удешевляет сервис`
          }, {
            class: `features__list-item`,
            text: `Сокращает затраты на поддержание бортового оборудования в рабочем состоянии`
          }, {
            class: `features__list-item`,
            text: `Снизить время простоев из-за возникновения неисправностей подсистем оборудоваиня`
          }, {
            class: `features__list-item`,
            text: `Создание комплексной картины работы бортового оборудования на транспортном средстве прямо на рабочем месте`
          }]
        }, {
          items: [{
            class: `features__list-item`,
            text: `Водитель`
          }, {
            class: `features__list-item`,
            text: `Инженер по БО`
          }, {
            class: `features__list-item`,
            text: `Управляющий парком ТС`
          }]
        }, {
          items: [{
            class: `features__list-item`,
            text: `ЦБК - единый центр связи для всей телеметрической инфраструктуры ТС`
          }, {
            class: `features__list-item`,
            text: `Накопление и преобразование данных от различных систем для передачи в центр мониторинга`
          }, {
            class: `features__list-item`,
            text: `Передача данных осуществляется по беспроводным каналам с возможностью резервирования в случае потери сигнала`
          }]
        }, {
          items: [{
            class: `features__list-item`,
            text: `С помощью 10.1 дюймового сенсорного экрана высокой контрастности`
          }, {
            class: `features__list-item`,
            text: `Единый интерфейс управления для разных ролей`
          }, {
            class: `features__list-item`,
            text: `Система удаленного управления, мониторинга и конфигурации подсистем`
          }]
        }, {
          items: [ {
            class: `features__list-item`,
            text: `Программа для ЭВМ «Встраиваемый программный комплекс реализующий информационно-коммуникационные и навигационные функции на борту общественных пассажирских транспортных средств»<br><br><a href="https://www1.fips.ru/registers-doc-view/fips_servlet?DB=EVM&DocNumber=2021616702", target="_blank", rel="noopener noreferrer" class="clr-white">Свидетельство о регистрации программы для ЭВМ № 2021616702 от 26.04.2021, выданное ФИПС</a>`
          },
          {
            class: `features__list-item`,
            text: `Программа включена в Единый реестр российских программ для электронных вычислительных машин и баз данных (<a href="https://reestr.digital.gov.ru/reestr/1043867/", target="_blank", rel="noopener noreferrer" class="clr-white">запись в реестре №15091 от 07.10.2022</a>)`
          }, {
            class: `features__list-item`,
            text: `Работа с центром мониторинга`
          }, {
            class: `features__list-item`,
            text: `Интеграция с уже действующими системами`
          }]
        }]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .features {
    padding-top: 7.24vw;
    padding-bottom: 16.56vw;

    @include respond-max(tablet) {
      padding-top: 4rem;
      padding-bottom: 4rem;
    }
  }

  .features__title {
    margin-bottom: 4rem;
  }

  .features__blocks {
    display: flex;
    flex-direction: column;
  }

  .features__block {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-bottom: 7.82vw;
    padding-top: 5.88vw;
    padding-left: 8px;
    border-top: 1px solid rgba($white, 0.3);

    &:last-of-type {
      margin-bottom: 0;
    }

    @include respond-max(tablet) {
      margin-bottom: 4rem;
      padding-top: 3rem;
    }
  }

  .features__block-icon {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    width: 2.875rem;
    height: 2.125rem;
    padding-right: 1.625rem;
    transform: translateY(-50%);

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .features__content {
    display: flex;

    @include respond-max(tablet) {
      flex-direction: column;
    }
  }

  .features__container {
    display: flex;
    flex-direction: column;

    &--first {
      flex-shrink: 0;
      width: 48.5vw;
      padding-right: 8%;

      @include respond-max(tablet) {
        width: 100%;
        margin-bottom: 4rem;
        padding-right: 0;
      }
    }

    &--second {
      flex-grow: 1;
      padding-right: 7.75vw;
    }

    p {
      margin-top: 1.5rem;
      line-height: 1.2;
    }
  }

  .features__block-title {
    @include font('t');
    font-size: 4.5rem;
    line-height: 1;
    letter-spacing: 0;
    word-break: break-word;

    @include respond-max(tablet) {
      font-size: 3rem;
    }
  }

  .features__subtitle {
    margin-bottom: 2.5rem;
  }

  /deep/.features__list-item {
    border-top: 1px solid rgba(#f0f0f0, 0.2);

    &:last-of-type {
      border-bottom: 1px solid rgba(#f0f0f0, 0.2);
    }

    &::before {
      color: $white;
    }
  }

  .features__scheme {
    width: 38.02vw;
    height: 14.06vw;

    @include respond-max(tablet) {
      align-self: center;
      width: 24rem;
      max-width: 100%;
      height: 12rem;
    }
  }

  .features__link {
    display: flex;
    align-items: center;
    svg {
      flex-shrink: 0;
      width: 1.125rem;
      height: 1.40625rem;
      margin-right: 0.875rem;
    }
  }
</style>
